const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

class CustomerConfigurationServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async getPublicAppConfiguration({ bookingChannelId }) {
    try {
      const { data } = await this.httpClient.get(`/v1/public/configurations/app-config?bookingChannelId=${bookingChannelId}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  CustomerConfigurationServiceConnector,
};
